export default __webpack_public_path__ + "static/media/profile.709d660d.png";